export const calendarQuery = `
  query EventsQuery($id: [QueryArgument], $section: [String], $limit: Int, $orderBy: String, $startDate: [QueryArgument], $relatedTo: [QueryArgument]) {
    entries(section: $section, id: $id, startDate: $startDate, orderBy: $orderBy, limit: $limit, relatedTo: $relatedTo, notPublic: false) {
      ... on events_Entry {
        id
        title
        url
        shortDescription
        startDate
        endDate
        eventAddress
        schoolCalendar {
          title
        }
        thumbnailImage {
          url
          ... on media_Asset {
            altText
          }
        }
      }
      ... on athleticEvents_Entry {
        id
        title
        url
        shortDescription
        startDate
        endDate
        eventAddress
        athleticCalendar {
          title
        }
        thumbnailImage {
          url
          ... on media_Asset {
            altText
          }
        }
      }
    }
    entryCount(section: $section, id: $id, startDate: $startDate, orderBy: $orderBy, limit: $limit, relatedTo: $relatedTo, notPublic: false)
  }
`

export const eventsCategoriesQuery = `
  query EventsCategoriesQuery($siteId: [QueryArgument]) {
    categories:entries(section: "schoolProgramFilters", siteId: $siteId,showInCalendar: true) {
      id
      title
      level
      parent {
        id
      }
      groupId:sectionId
      groupHandle:sectionHandle
    }
  }
`
